import $ from 'jquery';
import Handlebars from 'handlebars/runtime';
import { configs } from "./configurations";
import _filter from "lodash/filter";

let { templates, partials, helpers, getLocaleDate, getLocale, noresults } = configs;
let util = require("handlebars-utils");


const Radio_e_TV = 'Comunicati Radio tv e digital|Category-5992d6fe-2de2-444a-ad8c-2421ec15f2bb';
const Rai_Informa = ['COMUNICATI CDA|Category-01e0d5af-0210-4dac-bdff-3df318cbb4e8', 'Comunicati Aziendali|Category-0a9a3c8a-f274-4096-9721-501027395077'];
const Ascolti = 'Ascolti|Category-970b416a-8d16-4df0-a666-aeb0c8f31340';
const Conferenze_Stampa = 'Conferenze stampa|Category-41987c56-bbdc-4629-80a1-b784e38407b7';
const News_Rai = 'News Rai|Category-bf982ce0-bc69-45cb-b236-4135bf7066cc';
const Festival_di_Sanremo = 'Festival di Sanremo|Category-850fc4ff-bf81-458f-b6a3-9feafaebcbcd';
const Eurovision_Song_Contest = 'Eurovision Song Contest|Category-7fb87f94-c31f-4e57-852a-985da64aee05';
const Prix_Italia = 'Prix Italia|Category-d20257b2-b452-4877-9219-b2b4cbb395b8';
const Promo = 'Promo e Clip|Category-64d6ed88-4bdb-4d8d-b256-78ebf186070b';
const Interviste = 'Interviste|Category-bd9607a7-7655-4e12-a41c-1eef243d7385';
const Conferenze_Video_Foto = 'Conferenze Stampa VideoFoto|Category-c754e9dd-2417-4e16-ae49-bba5c299b3fd';
const RadioCorriereTV = 'Radiocorriere TV|Category-17f7e543-e819-4601-a072-97bbfbf31757';

let DEBUG = process.env.NODE_ENV === 'development';
DEBUG = false;

let ELASTIC_URL = 'https://www.rai.it/atomatic/rai-search-service/api/v2/ufficiostampa/search';

ELASTIC_URL = DEBUG ? ELASTIC_URL + '?transform=false' : ELASTIC_URL;

const SIZE = 16;

$(function () {
    main();
});

function main() {
    const query = {
        page: 1,
        param: null,
        filters: {
            tematica: [],
            tipo: [],
            tag: [], 
            tematiche: []
        },
        mode: null
    };
    function bindParamsFromUrl() {
        let query = new URLSearchParams(window.location.search.slice(1));
        const mode = $('body').data('archive-type');
        return {
            param: query.get('s'),
            filters: {
                tematica: query.getAll('tematica'),
                tipo: query.getAll('tipo'),
                tag: query.getAll('tag')
            }
        };
    }
  

    async function elasticCall(params) {

        //const url = ELASTIC_URL + (DEBUG ? '?transform=false' : '');
        const url = ELASTIC_URL;
        let reqParams = Object.assign({}, {
            from: (params.page - 1) * SIZE,
            pageSize: SIZE
        }, params);
        delete reqParams.page;
        try {
            let req = new Request(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                mode: 'cors',
                body: JSON.stringify(reqParams)
            });
            let resp = await fetch(req);
            if (resp.ok) {
                return await resp.json();
            }
            return null;
        } catch (e) {
            console.error(e);
            return null;
        }
        
    }

    let searchParams = (function () {
        const removeNulls = obj => Object.keys(obj).reduce((obj, k) => {
            if (Array.isArray(obj[k])) {
                if (obj[k].length === 0) {
                    delete obj[k];
                }
                return obj;
            }
            if (obj[k] === null) {
                delete obj[k];
            }
            if (typeof obj[k] === 'object') {
                obj[k] = removeNulls(obj[k]);
            }
            return obj;
        }, obj);

        let params = Object.assign({}, query, bindParamsFromUrl());
        return removeNulls(params);
    })();

    search(searchParams);


    function search(params) {

        params.mode = $('body').data('archive-type');

        elasticCall(params).then(resp => {
            let response = resp;
            if (DEBUG) {
                require('../Helpers/conditional-helpers').default(Handlebars);
                require('../Helpers/string').default(Handlebars);
                let out = require('../templates/search-output.hbs');
                response.hits.hits = response.hits.hits.map(hit => {
                    if (typeof hit._source.testo !== 'undefined') {
                        hit._source.testo = hit._source.testo.replace(/[^\x20-\x7E-\x27]+/g, '');
                    }
                    if (typeof hit._source.sommario !== 'undefined') {
                        hit._source.sommario = hit._source.sommario.replace(/[^\x20-\x7E-\x27]+/g, '');
                    }
                    if (typeof hit._source.titolo !== 'undefined') {
                        hit._source.titolo = hit._source.titolo.replace(/[^\x20-\x7E-\x27]+/g, '');
                    }
                    return hit;
                });
                let tmp = out(response);
                response = JSON.parse(tmp);
            }
            manageDom(response, params);
        });
    }

    $(document).on('click', 'a.load-more', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let page = (parseInt(e.target.dataset.page));
        getMoreCards(page);
        raiTrack.trackPage({ "cp": { 4: "show_more" } });
    });

    function getMoreCards(page = null) {
        if (!page) return;
        let params = Object.assign({}, { page }, bindParamsFromUrl());
        search(params, true);
    }
    function manageDom(resp, params = null) {
        if (!resp.hits.length) {
            msg.render(params.mode, params.filters);
            return;
        }
        
        switch (params.mode) {
            case 'comunicati':
                filters.render(filters.manage(resp.aggregations[0].by_tematiche, 'comunicati'));
                card.render(card.manage(resp.hits), (params.page !== 1));
                break;

            case 'ricerca':
                filters.render(filters.manage(resp.aggregations.all_type, 'ricerca'));
                window.raiTrack && window.trackPageWebtrekk && (
                    raiTrack.getPageInfo(),
                    raiTrack.pageInfo = Object.assign({}, raiTrack.pageInfo, {
                        internalSearch: "cerca per: " + bindParamsFromUrl().param
                    }),
                    window.trackPageWebtrekk())
                $('.filters a').on('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    let q = new URLSearchParams(window.location.search.slice(1));
                    q.delete('tipo');
                    let param = e.currentTarget.dataset.param;
                    if (param !== 'Tutti') {
                        q.set('tipo', param);
                    }
                    window.history.pushState({}, "", '?' + q);
                    let params = Object.assign({}, { page: 1 }, bindParamsFromUrl());
                    search(params);
                });
                card.render(card.manage(resp.hits), (params.page !== 1));
                break;
            case 'conferenze':
                card.render(card.manage(resp.hits), (params.page !== 1), 'conferenza');
                break;
            case 'media':
                const tipi = resp.aggregations.find(it => 'all_type' in it);
                const tematiche = resp.aggregations.find(it => 'by_tematiche' in it);
                const aggs = [].concat(...Object.values(tipi)).concat(...Object.values(tematiche));
                const filtriDaMandare = filters.render(filters.manage(aggs, 'media'));
                console.log(aggs);
                card.render(card.manage(resp.hits), (params.page !== 1));
                break;
            case 'allArticles':
                card.render(card.manage(resp.hits), (params.page !== 1));
                break;
            case 'pubblicazioni':
                card.render(card.manage(resp.hits), (params.page !== 1), 'pubblicazione');
                break;
        }

        let maxPage = Math.ceil(resp.total / SIZE);
        console.log(resp);
        if (params.page < maxPage) {
            pagination.render(++params.page);
        } else {
            pagination.render(null);
        }

    }
   
    const card = {
        manage: (cards) => {
            return cards.map((card) => {
                card.image = card.images.landscape || card.images.default || null;
                card.tipo = card.friendlyType.toLowerCase() || null;
                let date = card.data_pubblicazione || card.data_creazione;
                card.pubblication_date = moment.utc(card.data_pubblicazione).format('DD/MM/YYYY HH:mm');

                if (card.evento) {
                    card.evento.day = getLocale(new Date(card.evento.startDate), { day: 'numeric' });
                    card.evento.month = getLocale(new Date(card.evento.startDate));
                    card.evento.expired = (card.evento.startDate.substr("T", card.evento.startDate.indexOf("T")) < moment().format('YYYY-MM-DD'));
                }
                card.href = card.siti.find(sito => sito.nome === 'UfficioStampa').relative_url;
                card.target = '_self';
                card.label = card.label || 'RAI';
                return card;
            })
        },
        render: (cards, append = false, mode = 'normal') => {
            let archive = document.getElementsByClassName('archive')[0];
            let partialForArticle = partials[mode];
            let newHtml = templates.articles(cards, { partials: { 'article': partialForArticle } });
            newHtml = (append) ? archive.innerHTML + newHtml : newHtml;
            archive.innerHTML = newHtml;
            return cards;
        }
    };

    const pagination = {
        render: (page) => {
            let pagination = $('.load-more');
            if (!page) {
                pagination.remove();
                return;
            }
            if (pagination.length) {
                pagination.attr('data-page', page);
                return;
            }
            $(templates.pagination({ page })).insertAfter($('.archive'));
        }
    };

    const filters = {
        render: (filters) => {
            if (!filters.length) return;
            let $filters = $('.filters');
            $filters.html(templates.filters(filters));
            $('.header').addClass('has-filters');
        },
        manageOLD: (filters, type) => {
            let filterType = configs.mapping[type];
            return filters.reduce((tmp, filter) => {
                let currentFilter = filterType[filter.key];
                if (!currentFilter) return tmp;
                tmp.push({
                    'href': currentFilter.href,
                    'label': filter.key,
                    'occurrencies': filter.occurrencies
                });
                return tmp;
            }, [])
        },
        manage: (filters, type) => {
            if (!filters) return [];
            let filterType = configs.mapping[type];
            return filterType.reduce((tmp, filter) => {
                let key = Object.keys(filter)[0];
                let obj = _filter(filters, { key: key })[0];
                if (!obj){
                    const cat = filter[key].categories ? filter[key].categories[0] : undefined;
                    if(cat){
                        obj = _filter(filters,{key : cat} )[0];
                    }
                }
                if (!obj) return tmp;
                let active = (window.location.pathname + window.location.search === filter[key].href);
                if (window.location.pathname == '/ufficiostampa/ricerca.html') {
                    let q = new URLSearchParams(window.location.search.slice(1));
                    active = (key === 'Tutti');
                    if (q.has('tipo')) {
                        let paramType = q.get('tipo');
                        active = (paramType === key);
                    }
                }
                tmp.push({
                    'href': filter[key].href,
                    'label': filter[key].label,
                    'active': active,
                    'param': key,
                    'occurrencies': obj.occurrencies
                });
                
                return tmp;
            }, []);
        },

    };
   

    const msg = {
        render: (archiveType, filters) => {
            let data = noresults[archiveType];
            if (!data && archiveType !='media'){
                return;
            }
            if (!data && archiveType =='media'){
                let archive = document.getElementsByClassName('archive')[0];
                archive.innerHTML = templates.noresults(filters);
            }
            let archive = document.getElementsByClassName('archive')[0];
            archive.innerHTML = templates.noresults(data);
        }
    }



}
